import React from 'react';
import { BackgroundColorsMap } from '@milanlaser/mlcomponents';
import SpecialsBanner from './SpecialsBanner';
import { PromoCountdown } from './PromoCountdown';
import Navbar from './Navbar';
import { NO_RAZOR, MILAN_PHONE } from '../../utils';
import { usePromoCountdown } from '../../hooks/usePromoCountdown';
import SearchIcon from '../../images/shared/SearchIcon.png';
import PhoneIcon from '../../images/shared/PhoneIcon.png';

function HeaderBottom({ menu, searchView, setSearchView, showCountdown }) {
    const { countdown } = usePromoCountdown();
    // Below 992px the countdown sits inside this padded row, so the row takes the
    // banner's Builder color rather than showing navy around it (see Header.css).
    // has-countdown-bg is ours, so Header.css doesn't depend on the library's class names.
    const countdownBgClass =
        showCountdown && countdown ? `${BackgroundColorsMap[countdown.backgroundColor]} has-countdown-bg` : undefined;

    return (
        <section id="header-bottom" className={countdownBgClass}>
            <div className="container h-100">
                <div className="row justify-content-center align-items-center h-100">
                    {/* WEBDEV-4313: col-xl-12, not -11. The spare twelfth left the search/phone
                        column short from 1200-1279px and it wrapped below the menu; it also put
                        this row 85px narrower than HeaderTop, which is col-xl-12.
                        No col-xxl-10 either — see HeaderTop for why that step only subtracts. */}
                    <div className="col-xl-12 h-100">
                        <div className="row align-items-center h-100 position-relative gx-0">
                            <div className="col d-lg-none text-center">
                                {showCountdown ? <PromoCountdown /> : <SpecialsBanner supportsLineBreak />}
                            </div>
                            <div className="col-auto d-none d-lg-block h-100" style={{ zIndex: 99 }}>
                                <Navbar menu={menu} />
                            </div>
                            <div className="col d-none d-lg-block h-100 milan-bg-white" style={{ zIndex: 100 }}>
                                <div className="row justify-content-end align-items-center h-100 gx-4">
                                    {!searchView && (
                                        <div className="col-auto">
                                            <div
                                                id="header-search"
                                                className="py-2 pointer"
                                                onClick={() => setSearchView(true)}
                                            >
                                                <i>
                                                    <img
                                                        src={SearchIcon}
                                                        alt="Search Icon"
                                                        style={{ maxHeight: '20px' }}
                                                    />
                                                </i>
                                                <span className="ps-2">Search</span>
                                            </div>
                                        </div>
                                    )}
                                    <div className="col-auto">
                                        <div id="header-tel" className="py-2">
                                            <a href={`tel:${MILAN_PHONE}`} className="milan-dim-on-hover">
                                                <i>
                                                    <img
                                                        src={PhoneIcon}
                                                        alt="Phone Icon"
                                                        style={{ maxHeight: '28px' }}
                                                    />
                                                </i>
                                                <span className="ps-2">{NO_RAZOR}</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default HeaderBottom;
